<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-center">
        <h1 class="primary--text">Join DoleFund</h1>
      </v-col>
      <v-col cols="12" class="text-center">
        <p>
          DoleFund will be available in 2021.
        </p>
      </v-col>
      <v-col cols="12">
        <p>
          If you want to stay updated about when you can start using DoleFund, subscribe to our list to be the first to know with the form below.
        </p>
        <p>
          We will not send you any spam, the mailing list is purely to update you on when DoleFund is available so you can start donating.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <UserSignUpForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import UserSignUpForm from './UserSignUpForm.vue'

  export default {
    name: 'Subscribe',

    components: {
      UserSignUpForm
    },

    data: () => ({
    }),
  }
</script>
